const CONTAINER_TYPES = {
  ApiInterface: Symbol.for("ApiInterface"),
  ServiceInterface: Symbol.for("ServiceInterface"),
  ApplicationInterface: Symbol.for("ApplicationInterface"),
};

export { CONTAINER_TYPES };
